export function parseScopeFallback(text) {
  const txt = text.toLowerCase();
  const svcs = ["maint"];
  let cond = "norm";
  const detections = [];
  const flags = [];

  const im = txt.match(/(\d+)\s*[""'""]/);
  const inches = im ? parseInt(im[1]) : 0;
  if (inches > 12 || /neglect|abandon|very tall|out of control/.test(txt)) {
    cond = "negl";
    detections.push({ label: `${inches || "Very tall"}" grass — severely neglected`, tag: "Neglected", type: "warn" });
  } else if (inches > 5 || /overgrow|tall grass|hasn.{0,10}mow|grown up/.test(txt)) {
    cond = "over";
    detections.push({ label: `${inches || "Tall"}" grass — overgrown`, tag: "Overgrown", type: "warn" });
  }

  const rules = [
    [/\bhedges?\b/, "hedge", "Hedge trimming", "Hedge"],
    [/\bfertili/, "fert", "Fertilization", "Fert"],
    [/\bweed control\b|\bherbicide\b/, "weed", "Weed control", "Weed"],
    [/\baerat/, "aerate", "Aeration", "Aerate"],
    [/\bleaves?\b/, "leaves", "Leaf removal", "Leaves"],
    [/\b(?:flower\s+)?beds?\b(?!room)/, "bed", "Bed cleanup", "Beds"],
    [/\bmulch\b/, "mulch", "Mulch install", "Mulch"],
    [/\bpine straw\b/, "pine", "Pine straw", "Pine"],
    [/\bpressure wash\b|\bpower wash\b/, "pressure", "Pressure washing", "Pressure"],
    [/\bgutter\b/, "gutter", "Gutter cleaning", "Gutter"],
    [/\bcleanup\b|\bdebris\b|\binitial\b|\bfirst.{0,5}cut\b/, "firstcut", "Initial cleanup", "Cleanup"],
    [/\btree.*trim|\btrim.*tree|\bshrub\b|\bcrepe\b|\bcrape\b/, "shrub", "Tree/shrub trimming", "Trim"],
    [/\bsod\b/, "sod", "Sod install", "Sod"],
    [/\bseed\b|\boverseed/, "seed", "Overseeding", "Seed"],
    [/\bpre[_-]?emergent\b/, "pre", "Pre-emergent", "Pre-em"],
    [/\bbush hog\b/, "bushhog", "Bush hogging", "Bush hog"],
  ];
  rules.forEach(([regex, id, label, tag]) => {
    if (regex.test(txt)) {
      svcs.push(id);
      detections.push({ label, tag, type: "info" });
    }
  });

  return { condition: cond, services: [...new Set(svcs)], detections, flags };
}
